import React from 'react';
import { Box, Heading, Text, Link, HStack } from '@chakra-ui/react';

const JobOpeningHeader = () => (
  <Box bg="#25575F" pt={16} pb={24} px={{ base: 2, md: 12 }} textAlign="center" position="relative" bgImage="url('/png/career-header.png')" bgSize="contain" bgPosition="contain" bgRepeat="no-repeat">
    <HStack spacing={2} align="center" mb={6} pl={{ base: 2, md: 4 }}>
      <Text as="span" fontSize="xl" color="white" fontWeight="bold">←</Text>
      <Link href="/careers" color="white" fontWeight="bold" textDecor="underline" fontSize="md">Career</Link>
      <Text color="white" fontSize="md">/</Text>
      <Text color="white" fontSize="md">Job Listing</Text>
    </HStack>
    <Box position="relative" display="inline-block" mb={2}>
      <Heading
        as="h1"
        fontSize={{ base: '3xl', md: '5xl' }}
        color="#E6FF3F"
        fontWeight="bold"
        zIndex={2}
        lineHeight="1.1"
      >
        Job Listing
      </Heading>
    </Box>
    <Text color="white" fontSize={{ base: 'lg', md: '2xl' }} mt={4}>
      Secure the opportunity that matches your ambition
    </Text>
  </Box>
);

export default JobOpeningHeader; 